import React from 'react';
import cn from 'classnames';
import MetaText from "../../../../ui/Typography/texts/MetaText";
import styles from './ProductInformation.module.scss';
const ProductInformation = ({ tableData }) => {
    if (!tableData) {
        return null;
    }
    return (React.createElement("table", { className: styles.tableContainer },
        React.createElement("tbody", null, tableData.map(({ name, value }) => {
            const key = typeof name === 'string' ? name === null || name === void 0 ? void 0 : name.replace(/\s/g, '') : value;
            return (React.createElement("tr", { key: `${key}-row` },
                React.createElement("th", { className: cn(styles.tableHeading, styles.tableText) },
                    React.createElement(MetaText, null, name)),
                React.createElement("td", { className: styles.tableText },
                    React.createElement(MetaText, null, value))));
        }))));
};
export default ProductInformation;
//# sourceMappingURL=ProductInformation.js.map